import axiosInstance from './axiosInstance';

const updateSettings = async ({ token, privateCategory, privateSubcategory, language, privateCategoriesEnabled, bookCategory, chapterSubcategory }) => {
  try {
    const response = await axiosInstance.post(
      '/settings/update',
      { privateCategory, privateSubcategory, language, privateCategoriesEnabled, bookCategory, chapterSubcategory },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export { updateSettings };
